import ReactDOM from 'react-dom';
import { Popover } from "react-tiny-popover";
import { useState } from 'react';
import { setCallTag } from '../../api';
import { showError } from '../../utils';
import { ReactComponent as IconLoading } from '../../assets/icons/spinner.svg';

// Mappa colore HEX -> chiave tag
const COLOR_MAP = {
    "#CECCFD": "lavender",
    "#341BCC": "indigo",
    "#34EBFC": "cyan",
    "#BBFF00": "lime",
    "#1CB364": "green",
    "#FC3438": "red",
};
const COLORS = Object.keys(COLOR_MAP);
const COLOR_NONE = "#DDDDDD";

/**
 * TagColor component permette di selezionare un colore e inviare un tag all'API.
 * @param {string} id - ID della pagina padre.
 * @param {string} children - Chiave tag di fallback.
 * @param {string} [className] - Classe addizionale da applicare al pulsante.
 */
export function TagColor({ id, children: fallbackTag, className = '' }) {
    const [selectedColor, setSelectedColor] = useState(fallbackTag ?? COLOR_NONE);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [isLoading, setIsLoading] = useState({});

    const handleColorSelect = async (color) => {
        setIsLoading({...isLoading, [id]: true});
        const tag = COLOR_MAP[color] || fallbackTag;
        try {
            await setCallTag(id, tag);
            setSelectedColor(color);
        } catch (e) {
            showError([e.message]);
        } finally {
            setIsPopoverOpen(false);
            setIsLoading({...isLoading, [id]: false});
        }
    };

    return (
        <>
            {isPopoverOpen &&
                ReactDOM.createPortal(
                    <div className="tag-color-overlay" />,
                    document.body
                )
            }        
            <Popover
                isOpen={isPopoverOpen}
                positions={["bottom", "top"]}           
                transform={{ left: -30 }}
                transformMode='relative'
                onClickOutside={() => setIsPopoverOpen(false)}
                appendTo={() => document.body}
                content={
                    <div className="tag-color-opts">
                        {COLORS.map((color) => (
                            <button
                                key={color}
                                onClick={() => handleColorSelect(color)}
                                className="btn-tag-color-opt"
                                style={{ backgroundColor: color }}
                            />
                        ))}
                    </div>
                }
            >
                {isLoading[id] ? <IconLoading className="icon icon-loading btn-tag-color"/> :
                    <button
                        className={`btn-tag-color ${className}`}
                        style={{ backgroundColor: selectedColor }}
                        onClick={() => setIsPopoverOpen((prev) => !prev)}
                    />
                }
            </Popover>
        </>
    );
}
